import React, { useState, useEffect } from 'react';
import { useHistory } from "react-router-dom";
import Header from '../../Shared/Header';
import Footer from '../../Shared/Footer';
import Footer2 from '../../Shared/Footer2';
import DropDownTable from '../../Shared/DropDownTable';
import { useParams } from "react-router-dom";
import 'react-calendar/dist/Calendar.css';
import TermsConditionModal from '../../Shared/TermsConditionModal';
import Input from '../../Shared/Input';
import Button from '../../Shared/Button';
import '../../../css/ProfileManagement/DriverProfile.css'
import save from '../../../Assets/ProfileManagement/Assets-Desktop/arrow-left.svg';
import savedark from '../../../Assets/ProfileManagement/Assets-Desktop/userprofile.svg';
import edit from '../../../Assets/ProfileManagement/Assets-Desktop/edit.svg';
import editlight from '../../../Assets/ProfileManagement/Assets-Desktop/editenable.svg';
import downarrow from '../../../Assets/ProfileManagement/Assets-Desktop/arrow-down.svg';
import updrawer from '../../../Assets/ProfileManagement/Assets-Desktop/arrow-up.svg';
import calender from '../../../Assets/ProfileManagement/Assets-Desktop/calender.svg';
import defautRadioButton from '../../../Assets/ProfileManagement/Assets-Desktop/defautRadioButton.svg'
import selectedRadioButton from '../../../Assets/ProfileManagement/Assets-Desktop/selectedRadioButton.svg'
import 'bootstrap/dist/css/bootstrap.min.css';
import SubmitModal from '../../Shared/SubmitModal';
import Upload from '../../Shared/UploadFile';
import Calendar from 'react-calendar';
import Message from '../../../Data/Shared/Message.json';
import ColorCode from '../../../Data/Shared/ColorCode.json';
import MetaDecorator from '../../../ReactHelmet/MetaDecorator';
import TitleDescription from '../../../Data/Shared/TitleDescription.json';
import AddProfileModal from '../../Shared/GenericModalError';
import POPIDisclaimerModal from '../../Shared/POPIDisclaimerModal';
import { AES, enc } from 'crypto-js';
// for redux
import { useSelector } from 'react-redux';
//api url
import { utilityBaseURL, workFlowBaseURL, baseURL } from '../../../Services/config/apiGateway';
import {
    COUNTRY_ENDPOINT, START_PROFILE_ENDPOINT, COMPLETE_PROFILE_FORM_ENDPOINT,
    GET_ALL_PROFILE_ENDPOINT, GET_ALL_PROFILE_DETAILS_ENDPOINT, PROFILE_ENDPOINT,
    REWORK_PROFILE, VALIDATE_DRIVING_LICENCE
} from '../../../Services/config/apiEndPoints';
import { ApiCall } from '../../../Services/utils/ApiCall';
import Loader from "react-loader";
let tempTaskId;
const DriverProfile = () => {
    const pathObj = useParams();
    const userProfileDataR = useSelector(state => JSON.parse(AES.decrypt(state.userProfileInfoReducer.data, 'TPT_CARGO_CONNECT').toString(enc.Utf8)));
    let history = useHistory();
    const [countries, setCountries] = useState([]);
    // for loader and page disable
    const [loadertime, setloadertime] = useState(false);
    const [pageDisable, setPageDisable] = useState(false);
    // pending modal
    const [hasOpenPending, setHasOpenPending] = useState(false);
    const [driverLicenceError, setDriverLicenceError] = useState(false);
    const [hasOpenterms, setHasOpenTerms] = useState(false);
    let [roletype, setroletype] = useState('');
    const [contrycode, setContrycode] = useState(false);
    const [contrycodep, setContrycodep] = useState(false);
    const container = React.createRef();
    const [hasOpen, setHasOpen] = useState(false);
    const [country, setCountry] = useState("");
    const [countryp, setCountryp] = useState("");
    const [passportNum, setPassportNum] = useState();
    const [passportDOBDate, setPassportDOBDate] = useState();
    const [SACitizenDOBDate, setSACitizenDOBDate] = useState();
    const [nationalId, setNationalId] = useState();
    const [drivingLicenseNum, setDrivingLicenseNum] = useState();
    const [drivingExpiryDate, setDrivingExpiryDate] = useState();
    const [calendarValueDriver, setCalendarValueDriver] = useState(new Date());
    const [showCalendar, setShowCalendar] = useState(false);
    const [dateSet, setDateSet] = useState(false);
    //passport expiry
    const [passDOBValue, setPassDOBValue] = useState(new Date());
    //sa dob 
    const [SACitizenDOBValue, setSACitizenDOBValue] = useState(new Date());
    const [showPassDOBCalendar, setShowPassDOBCalendar] = useState(false);
    const [showSACitizenDOBCalendar, setShowSACitizenDOBCalendar] = useState(false);
    const [dateDOBExpirySet, setDateDOBExpirySet] = useState(false);
    const [dateDOBSACitizenSet, setDateDOBSACitizenSet] = useState(false);
    const [phone, setPhone] = useState(false);
    const profileApproved = ['Approved', 'approved', 'APPROVED'];
    const profilePending = ['Pending', 'pending', 'PENDING'];
    const profileIncomplete = ['Not Completed', 'Not completed', 'not completed', 'NOT COMPLETED'];
    const profileReject = ['Rejected', 'rejected', 'REJECTED'];
    const [roleName, setroleName] = useState('');
    const [getTaskId, setGetTaskId] = useState('');
    const [roleID, setRoleID] = useState('');
    const [clickEdit, setClickEdit] = useState(false);
    const [clickSave, setClickSave] = useState(false);
    const [clickId, setClickId] = useState(false);
    const clickPassId = false;
    const [clickSC, setClickSC] = useState(false);
    let [selectOneRadioError, setSelectOneRadioerror] = useState();
    let [passportNumError, setPassportNumError] = useState();
    let [passportDOBDateError, setPassportDOBDateError] = useState();
    let [SACitizenDOBDateError, setSACitizenDOBDateError] = useState();
    let [nationalIdError, setNationalIdError] = useState();
    let [drivingLicenseNumError, setDrivingLicenseNumError] = useState();
    let [drivingExpiryDateError, setDrivingExpiryDateError] = useState();
    let [countryError, setCountryError] = useState();
    let [countrypError, setCountrypError] = useState();
    let [uploadError, setUploadError] = useState();
    let [upload1Error, setUpload1Error] = useState();
    let [upload2Error, setUpload2Error] = useState();
    const [SelectRadioSACitizen, setSelectRadioSACitizen] = useState(false);
    const [SelectRadioForeignDriver, setSelectRadioForeignDriver] = useState(false);
    const [filePathPassport, setFilePathPassport] = useState('');
    const [filePathNational, setFilePathNational] = useState('');
    const [filePathDriver, setFilePathDriver] = useState('');
    const [fileNamePassport, setFileNamePassport] = useState('');
    const [fileNameNational, setFileNameNational] = useState('');
    const [fileNameDriver, setFileNameDriver] = useState('');
    const [uploadFileDisableDriver, setUploadFileDisableDriver] = useState(false);
    const [uploadFileDisablePassport, setUploadFileDisablePassport] = useState(false);
    const [uploadFileDisableNational, setUploadFileDisableNational] = useState(false);
    const [hasOpenPOPIDisclaimer, setHasOpenPOPIDisclaimer] = useState(false);
    const [hasAgreePOPIDisclaimer, setHasAgreePOPIDisclaimer] = useState(false);
    let [viewProfileStatus, setViewProfileStatus] = useState('');
    // for remove require after upload file 
    const uploadFileFunPassport = (uploadConfirm) => {
        setUpload2Error("");
        document.getElementById('passportUpload').style.borderColor = ColorCode.colorCode.black;
    }
    const uploadFileFunNational = (uploadConfirm) => {
        setUpload1Error("");
        document.getElementById('nationalUpload').style.borderColor = ColorCode.colorCode.black;
    }
    const uploadFileFunDriver = (uploadConfirm) => {
        setUploadError("");
        document.getElementById('drivingUpload').style.borderColor = ColorCode.colorCode.black;
    }
    const removePassPortUploadedLink = () => {
        let path = "";
        setFilePathPassport(path);
        setFileNamePassport(path);
    }
    const removeNationalUploadedLink = () => {
        let path = "";
        setFilePathNational(path);
        setFileNameNational(path);
    }
    const removeDriverUploadedLink = () => {
        let path = "";
        setFilePathDriver(path);
        setFileNameDriver(path);
    }
    // uploaded file path
    const setUploadLinkPassport = (filePathURL) => {
        setFilePathPassport(filePathURL);
        setFileNamePassport(`Passport.${filePathURL?.split('/')[11]?.split("'")[0]?.split('.')[1]}`);
        // for loader end
        setloadertime(false);
        setPageDisable(false);
    }
    const setUploadLinkNational = (filePathURL) => {
        setFilePathNational(filePathURL);
        setFileNameNational(`National_Id.${filePathURL?.split('/')[11]?.split("'")[0]?.split('.')[1]}`);
        // for loader end
        setloadertime(false);
        setPageDisable(false);
    }
    const setUploadLinkDriver = (filePathURL) => {
        setFilePathDriver(filePathURL);
        setFileNameDriver(`Driving_License.${filePathURL?.split('/')[11]?.split("'")[0]?.split('.')[1]}`);
        // for loader end
        setloadertime(false);
        setPageDisable(false);
    }
    // for loader start
    const setLoaderDriver = (filePathURL) => {
        setloadertime(filePathURL);
        setPageDisable(filePathURL);
    }
    const setLoaderPassport = (filePathURL) => {
        setloadertime(filePathURL);
        setPageDisable(filePathURL);
    }
    const setLoaderNational = (filePathURL) => {
        setloadertime(filePathURL);
        setPageDisable(filePathURL);
    }
    const toggleCalendar = () => {
        setShowCalendar(!showCalendar);
        setDateSet(true);
    }
    const togglePassDOBCalendar = () => {
        setShowPassDOBCalendar(!showPassDOBCalendar);
        setDateDOBExpirySet(true);
    }
    const toggleSACitizenDOBCalendar = () => {
        setShowSACitizenDOBCalendar(!showSACitizenDOBCalendar);
        setDateDOBSACitizenSet(true);
    }
    const onClosetermsModal = () => {
        setHasOpenTerms(false);
    };
    const getDateFormated = (timeStamp) => {
        let date = new Date(Number(timeStamp)).toString();
        let day = date?.split(' ')[2];
        let month = date?.split(' ')[1];
        let year = date?.split(' ')[3];
        return `${day}-${month}-${year}`;
    }
    const getCountryCode = () => {
        ApiCall(
            'GET',
            utilityBaseURL + COUNTRY_ENDPOINT,
            {},
            {
                Accept: 'application/json',
                'Content-Type': 'application/json',
            },
        ).then((apiData) => {
            if (apiData.flag != -1) {
                if (apiData.flag == 500) {
                    console.log('I am 500!');
                }
                else {
                    console.log('I am 200!');
                    setCountries(apiData)
                }
            }
            else {
                console.log(`Some error occured - ${apiData.errorMessage}`);
            }
        });
    }
    useEffect(() => {
        //get all countries
        getCountryCode();
        const { roleId, roleTypeValue, roleNameValue, profileTypeAndStatusValue } = pathObj;
        setroletype(roleTypeValue);
        setroleName(roleNameValue);
        setRoleID(roleId)
        setViewProfileStatus(profileTypeAndStatusValue);
        document.addEventListener("mousedown", handleClickOutside);
        if (["Not Completed", 'Not completed', "not completed", "NOT COMPLETED", 'rejected', "Rejected", "REJECTED"].includes(profileTypeAndStatusValue) || profileTypeAndStatusValue === "add-profile") {
            viewProfileDataAndTaskId(roleTypeValue, profileTypeAndStatusValue);
        } else if (["Approved", "approved", "APPROVED"].includes(profileTypeAndStatusValue)) {
            viewPorfileDataOfApproved();
        }
        else if (['Pending', 'pending', 'PENDING'].includes(profileTypeAndStatusValue)) {
            viewPorfileDataOfPending(roleTypeValue);
        }
        if (!clickSC) {
            let phoneCheck = true;
            //view profile
            if (profileApproved.includes(profileTypeAndStatusValue) || profilePending.includes(profileTypeAndStatusValue) || profileIncomplete.includes(profileTypeAndStatusValue) || profileReject.includes(profileTypeAndStatusValue)) {
                // phonecheck by default true
                setPhone(true);
            }
            //add profile
            if (profileTypeAndStatusValue === 'add-profile') {
                phoneCheck = false;
                setPhone(false);
                roletype = "";
            }
            if (phoneCheck) {
                document.getElementById('drivingUpload').readOnly = true;
                document.getElementById('drivingLicenseNum').readOnly = true;
                setClickId(true);
                if (profilePending.includes(profileTypeAndStatusValue)) {
                    setHasOpenPending(true);
                    document.getElementById('bttn').style.display = 'none';
                }
            }
        }
    }, []);
    // view profile for not complete
    const viewProfileDataAndTaskId = (roleTypeValue, viewProfileTypeAndStatus) => {
        ApiCall(
            'GET',
            workFlowBaseURL + GET_ALL_PROFILE_ENDPOINT,
            {},
            {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                // 'x-cc-api-key': '1234',
            },
        ).then(data => {
            if (data.flag != -1) {
                if (data.flag == 500) {
                    console.log("I am 500")
                }
                else {
                    console.log('I am 200!');
                    data?.map((i, index) => (
                        data[index].taskData.profileUpdateRequest = JSON.parse(data[index].taskData.profileUpdateRequest)
                    ))
                    data?.every((md, index) => {
                        if (roleTypeValue?.includes(md.taskData.profileUpdateRequest.profileRole.roleType)) {
                            setGetTaskId(md.taskId)
                            //set data for view profile 
                            // view data for driving details
                            setFileNameDriver(md.taskData.profileUpdateRequest.drivingLicenseDetails?.drivingDocument?.documentName);
                            setUploadFileDisableDriver(md.taskData.profileUpdateRequest.drivingLicenseDetails?.drivingDocument?.documentName?.length > 0 ? true : false)
                            setFilePathDriver(md.taskData.profileUpdateRequest.drivingLicenseDetails?.drivingDocument?.documentPicture);
                            setDrivingLicenseNum(md.taskData.profileUpdateRequest.drivingLicenseDetails?.drivingLicenceNo);
                            if (md.taskData.profileUpdateRequest.drivingLicenseDetails?.drivingExpiryDate) {
                                setDrivingExpiryDate(getDateFormated(md.taskData.profileUpdateRequest.drivingLicenseDetails?.drivingExpiryDate));
                                setCalendarValueDriver(new Date(md.taskData.profileUpdateRequest.drivingLicenseDetails?.drivingExpiryDate));
                            }
                            setCountry(md.taskData.profileUpdateRequest.drivingLicenseDetails?.drivingIssueCountry);
                            if (md.taskData.profileUpdateRequest.identityDetails.idType === "Passport") {
                                setPassportNum(md.taskData.profileUpdateRequest.identityDetails.idNumber);
                                setCountryp(md.taskData.profileUpdateRequest.identityDetails.country);
                                setFilePathPassport(md.taskData.profileUpdateRequest.identityDetails?.idDocument?.documentPicture);
                                setFileNamePassport(md.taskData.profileUpdateRequest.identityDetails?.idDocument?.documentName);
                                setUploadFileDisablePassport(md.taskData.profileUpdateRequest.identityDetails?.idDocument?.documentName?.length > 0 ? true : false)
                                if (md.taskData.profileUpdateRequest.identityDetails?.expiryDate) {
                                    setPassportDOBDate(getDateFormated(md.taskData.profileUpdateRequest.identityDetails?.expiryDate));
                                    setPassDOBValue(new Date(md.taskData.profileUpdateRequest.identityDetails?.expiryDate));
                                }
                                setSelectRadioForeignDriver(true);
                            } else if (md.taskData.profileUpdateRequest.identityDetails.idType === "NationalID") {
                                setNationalId(md.taskData.profileUpdateRequest.identityDetails.idNumber);
                                setFilePathNational(md.taskData.profileUpdateRequest.identityDetails?.idDocument?.documentPicture);
                                setFileNameNational(md.taskData.profileUpdateRequest.identityDetails?.idDocument?.documentName);
                                setUploadFileDisableNational(md.taskData.profileUpdateRequest.identityDetails?.idDocument?.documentName?.length > 0 ? true : false);
                                if (md.taskData.profileUpdateRequest.identityDetails?.dob) {
                                    setSACitizenDOBDate(getDateFormated(md.taskData.profileUpdateRequest.identityDetails?.dob));
                                    setSACitizenDOBValue(new Date(md.taskData.profileUpdateRequest.identityDetails?.dob));
                                }
                                setSelectRadioSACitizen(true);
                            }
                            return false
                        }
                        return true
                    })
                }
            }
            else {
                console.log('something went wrong');
            }
        })
    }
    // view data for pending
    const viewPorfileDataOfPending = (roleTypeValue) => {
        ApiCall(
            'GET',
            workFlowBaseURL + GET_ALL_PROFILE_DETAILS_ENDPOINT,
            {},
            {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                // 'x-cc-api-key': '1234',
            },
        ).then(data => {
            if (data.flag != -1) {
                if (data.flag == 500) {
                    console.log("I am 500")
                }
                else {
                    console.log('I am 200!');
                    data?.map((i, index) => (
                        data[index].taskData.profileUpdateRequest = JSON.parse(data[index].taskData.profileUpdateRequest)
                    ))
                    //sort based on submit date
                    data?.sort((a, b) =>
                        b.taskData.profileUpdateRequest?.submitDate - a.taskData.profileUpdateRequest?.submitDate
                    )
                    data?.every((md, index) => {
                        if (roleTypeValue.includes(md.taskData.profileUpdateRequest.profileRole.roleType) && ['ReviewProfile', 'reviewProfile'].includes(md.taskName)) {
                            //set data for view profile 
                            // view data for driving details
                            setFileNameDriver(md.taskData.profileUpdateRequest.drivingLicenseDetails?.drivingDocument?.documentName);
                            setUploadFileDisableDriver(md.taskData.profileUpdateRequest.drivingLicenseDetails?.drivingDocument?.documentName?.length > 0 ? true : false)
                            setFilePathDriver(md.taskData.profileUpdateRequest.drivingLicenseDetails?.drivingDocument?.documentPicture);
                            setDrivingLicenseNum(md.taskData.profileUpdateRequest.drivingLicenseDetails?.drivingLicenceNo);
                            if (md.taskData.profileUpdateRequest.drivingLicenseDetails?.drivingExpiryDate) {
                                setDrivingExpiryDate(getDateFormated(md.taskData.profileUpdateRequest.drivingLicenseDetails?.drivingExpiryDate));
                                setCalendarValueDriver(new Date(md.taskData.profileUpdateRequest.drivingLicenseDetails?.drivingExpiryDate));
                            }
                            setCountry(md.taskData.profileUpdateRequest.drivingLicenseDetails?.drivingIssueCountry);
                            if (md.taskData.profileUpdateRequest.identityDetails.idType === "Passport") {
                                setPassportNum(md.taskData.profileUpdateRequest.identityDetails.idNumber);
                                setCountryp(md.taskData.profileUpdateRequest.identityDetails.country);
                                setFilePathPassport(md.taskData.profileUpdateRequest.identityDetails?.idDocument?.documentPicture);
                                setFileNamePassport(md.taskData.profileUpdateRequest.identityDetails?.idDocument?.documentName);
                                setUploadFileDisablePassport(md.taskData.profileUpdateRequest.identityDetails?.idDocument?.documentName?.length > 0 ? true : false)
                                if (md.taskData.profileUpdateRequest.identityDetails?.expiryDate) {
                                    setPassportDOBDate(getDateFormated(md.taskData.profileUpdateRequest.identityDetails?.expiryDate));
                                    setPassDOBValue(new Date(md.taskData.profileUpdateRequest.identityDetails?.expiryDate));
                                }
                                setSelectRadioForeignDriver(true);
                            } else if (md.taskData.profileUpdateRequest.identityDetails.idType === "NationalID") {
                                setNationalId(md.taskData.profileUpdateRequest.identityDetails.idNumber);
                                setFilePathNational(md.taskData.profileUpdateRequest.identityDetails?.idDocument?.documentPicture);
                                setFileNameNational(md.taskData.profileUpdateRequest.identityDetails?.idDocument?.documentName);
                                setUploadFileDisableNational(md.taskData.profileUpdateRequest.identityDetails?.idDocument?.documentName?.length > 0 ? true : false);
                                if (md.taskData.profileUpdateRequest.identityDetails?.dob) {
                                    setSACitizenDOBDate(getDateFormated(md.taskData.profileUpdateRequest.identityDetails?.dob));
                                    setSACitizenDOBValue(new Date(md.taskData.profileUpdateRequest.identityDetails?.dob));
                                }
                                setSelectRadioSACitizen(true);
                            }
                            return false
                        }
                        return true
                    })
                }
            }
            else {
                console.log('something went wrong');
            }
        })
    }
    // for approved view profile
    const viewPorfileDataOfApproved = () => {
        ApiCall(
            'GET',
            baseURL + PROFILE_ENDPOINT + `?userName=${userProfileDataR?.userEmail}`,
            {},
            {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
            }
        ).then(data => {
            if (data.flag != -1) {
                if (data.flag == 500) {
                    console.log('I am 500!');
                }
                else {
                    console.log('I am 200!');
                    // view data for driving details
                    setFileNameDriver(data.drivingLicenseDetails?.drivingDocument?.documentName);
                    setUploadFileDisableDriver(data.drivingLicenseDetails?.drivingDocument?.documentName?.length > 0 ? true : false)
                    setFilePathDriver(data.drivingLicenseDetails?.drivingDocument?.documentPicture);
                    setDrivingLicenseNum(data.drivingLicenseDetails?.drivingLicenceNo);
                    if (data.drivingLicenseDetails?.drivingLicenseExpiryDate) {
                        setDrivingExpiryDate(getDateFormated(data.drivingLicenseDetails?.drivingLicenseExpiryDate));
                        setCalendarValueDriver(new Date(data.drivingLicenseDetails?.drivingLicenseExpiryDate));
                    }
                    setCountry(data.drivingLicenseDetails?.issuedCountry);
                    if (data.identityDetails.idType === "Passport") {
                        setPassportNum(data.identityDetails.idNumber);
                        setCountryp(data.identityDetails.country);
                        setFilePathPassport(data.identityDetails?.idDocument?.documentPicture);
                        setFileNamePassport(data.identityDetails?.idDocument?.documentName);
                        setUploadFileDisablePassport(data.identityDetails?.idDocument?.documentName?.length > 0 ? true : false)
                        if (data.identityDetails?.expiryDate) {
                            setPassportDOBDate(getDateFormated(data.identityDetails?.expiryDate));
                            setPassDOBValue(new Date(data.identityDetails?.expiryDate));
                        }
                        setSelectRadioForeignDriver(true);
                    } else if (data.identityDetails.idType === "NationalID") {
                        setNationalId(data.identityDetails.idNumber);
                        setFilePathNational(data.identityDetails?.idDocument?.documentPicture);
                        setFileNameNational(data.identityDetails?.idDocument?.documentName);
                        setUploadFileDisableNational(data.identityDetails?.idDocument?.documentName?.length > 0 ? true : false);
                        if (data.identityDetails?.dob) {
                            setSACitizenDOBDate(getDateFormated(data.identityDetails?.dob));
                            setSACitizenDOBValue(new Date(data.identityDetails?.dob));
                        }
                        setSelectRadioSACitizen(true);
                    }
                }
            }
            else {
                console.log('something went wrong');
            }
        })
    }
    const workFlowReworkDriver = (formAction) => {
        ApiCall(
            'POST',
            workFlowBaseURL + REWORK_PROFILE + `?taskId=${getTaskId}`,
            {
                "email": userProfileDataR?.userEmail,
                "firstName": userProfileDataR?.firstName,
                "lastName": userProfileDataR?.lastName,
                "mobileNumber": userProfileDataR?.userMobile,
                "drivingLicenseDetails": {
                    "drivingDocument": {
                        "documentName": fileNameDriver,
                        "documentPicture": filePathDriver
                    },
                    "drivingLicenceNo": drivingLicenseNum,
                    "drivingLicenseExpiryDate": Date.parse(calendarValueDriver),
                    "issuedCountry": country
                },
                "identityDetails": {
                    // field not avalable for passport and nation date of birth
                    "country": SelectRadioForeignDriver ? countryp : '',
                    'dob': SelectRadioForeignDriver ? '' : (SelectRadioSACitizen ? Date.parse(SACitizenDOBValue) : ''),
                    "expiryDate": SelectRadioForeignDriver ? Date.parse(passDOBValue) : '',
                    "idDocument": {
                        "documentName": SelectRadioForeignDriver ? fileNamePassport : (SelectRadioSACitizen ? fileNameNational : ''),
                        "documentPicture": SelectRadioForeignDriver ? filePathPassport : (SelectRadioSACitizen ? filePathNational : '')
                    },
                    "idNumber": SelectRadioForeignDriver ? passportNum : (SelectRadioSACitizen ? nationalId : ''),
                    "idType": SelectRadioForeignDriver ? "Passport" : (SelectRadioSACitizen ? "NationalID" : '')
                },
                "profileRole": {
                    "roleId": roleID,
                    "roleName": roleName,
                    "roleType": roletype,
                },
                "userId": userProfileDataR?.userId,
                "submitDate": new Date().getTime()
            },
            {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
            }
        ).then(data => {
            if (data.flag != -1) {
                if (data.flag == '500') {
                    console.log('I am 500!');
                } else {
                    console.log('I am 200!');
                    if (formAction === 'submit') {
                        setHasOpen(true);
                    }
                    // call get user task for fetch task id for save only
                    else {
                        //set save value for second time save calling
                        //get task id
                        viewProfileDataAndTaskId(roletype, viewProfileStatus);
                    }
                }
            }
            else {
                console.log('Something went wrong!');
            }
        })
    }
    const workFlowApiNewDriver = (formAction) => {
        ApiCall(
            'POST',
            workFlowBaseURL + START_PROFILE_ENDPOINT + `?action=${formAction}`,
            {
                "email": userProfileDataR?.userEmail,
                "firstName": userProfileDataR?.firstName,
                "lastName": userProfileDataR?.lastName,
                "mobileNumber": userProfileDataR?.userMobile,
                "drivingLicenseDetails": {
                    "drivingDocument": {
                        "documentName": fileNameDriver,
                        "documentPicture": filePathDriver
                    },
                    "drivingLicenceNo": drivingLicenseNum,
                    "drivingLicenseExpiryDate": Date.parse(calendarValueDriver),
                    "issuedCountry": country
                },
                "identityDetails": {
                    "country": SelectRadioForeignDriver ? countryp : '',
                    'dob': SelectRadioForeignDriver ? '' : (SelectRadioSACitizen ? Date.parse(SACitizenDOBValue) : ''),
                    "expiryDate": SelectRadioForeignDriver ? Date.parse(passDOBValue) : '',
                    "idDocument": {
                        "documentName": SelectRadioForeignDriver ? fileNamePassport : (SelectRadioSACitizen ? fileNameNational : ''),
                        "documentPicture": SelectRadioForeignDriver ? filePathPassport : (SelectRadioSACitizen ? filePathNational : '')
                    },
                    "idNumber": SelectRadioForeignDriver ? passportNum : (SelectRadioSACitizen ? nationalId : ''),
                    "idType": SelectRadioForeignDriver ? "Passport" : (SelectRadioSACitizen ? "NationalID" : '')
                },
                "profileRole": {
                    "roleId": roleID,
                    "roleName": roleName,
                    "roleType": roletype,
                },
                "userId": userProfileDataR?.userId,
                "submitDate": new Date().getTime()
            },
            {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
            }
        ).then(data => {
            if (data.flag != -1) {
                if (data.flag == '500') {
                    console.log('I am 500!');
                } else {
                    console.log('I am 200!');
                    // show when user perform submit and open modal
                    if (formAction === 'submit') {
                        setHasOpen(true);
                    }
                    // call get user task for fetch task id for save only
                    else {
                        //set save value for second time save calling
                        //get task id
                        viewProfileDataAndTaskId(roletype, viewProfileStatus);
                    }
                }
            }
            else {
                console.log('Something went wrong!');
            }
        })
    }
    const workFlowApiCompleteDriver = (formAction) => {
        ApiCall(
            'GET',
            workFlowBaseURL + GET_ALL_PROFILE_ENDPOINT,
            {},
            {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                // 'x-cc-api-key': '1234',
            },
        ).then(data => {
            if (data.flag != -1) {
                if (data.flag == 500) {
                    console.log("I am 500")
                }
                else {
                    console.log('I am 200!');
                    data?.map((i, index) => (
                        data[index].taskData.profileUpdateRequest = JSON.parse(data[index].taskData.profileUpdateRequest)
                    ))
                    data?.every((md, index) => {
                        if (roletype.includes(md.taskData.profileUpdateRequest.profileRole.roleType)) {
                            setGetTaskId(md.taskId);
                            tempTaskId = md.taskId;
                            return false
                        }
                        return true
                    })
                    ApiCall(
                        'POST',
                        workFlowBaseURL + COMPLETE_PROFILE_FORM_ENDPOINT + `?action=${formAction}&taskId=${tempTaskId}&userId=${userProfileDataR?.userId}`,
                        {
                            "email": userProfileDataR?.userEmail,
                            "firstName": userProfileDataR?.firstName,
                            "lastName": userProfileDataR?.lastName,
                            "mobileNumber": userProfileDataR?.userMobile,
                            "drivingLicenseDetails": {
                                "drivingDocument": {
                                    "documentName": fileNameDriver,
                                    "documentPicture": filePathDriver
                                },
                                "drivingLicenceNo": drivingLicenseNum,
                                "drivingLicenseExpiryDate": Date.parse(calendarValueDriver),
                                "issuedCountry": country
                            },
                            "identityDetails": {
                                "country": SelectRadioForeignDriver ? countryp : '',
                                'dob': SelectRadioForeignDriver ? '' : (SelectRadioSACitizen ? Date.parse(SACitizenDOBValue) : ''),
                                "expiryDate": SelectRadioForeignDriver ? Date.parse(passDOBValue) : '',
                                "idDocument": {
                                    "documentName": SelectRadioForeignDriver ? fileNamePassport : (SelectRadioSACitizen ? fileNameNational : ''),
                                    "documentPicture": SelectRadioForeignDriver ? filePathPassport : (SelectRadioSACitizen ? filePathNational : '')
                                },
                                "idNumber": SelectRadioForeignDriver ? passportNum : (SelectRadioSACitizen ? nationalId : ''),
                                "idType": SelectRadioForeignDriver ? "Passport" : (SelectRadioSACitizen ? "NationalID" : '')
                            },
                            "profileRole": {
                                "roleId": roleID,
                                "roleName": roleName,
                                "roleType": roletype
                            },
                            "userId": userProfileDataR?.userId,
                            "submitDate": new Date().getTime()
                        },
                        {
                            'Accept': 'application/json',
                            'Content-Type': 'application/json',
                        }
                    ).then(apiData => {
                        if (apiData.flag != -1) {
                            if (apiData.flag == '500') {
                                console.log('I am 500!');
                            } else {
                                console.log('I am 200!');
                                // for show when user submit profile
                                if (formAction === 'submit') {
                                    setHasOpen(true);
                                }
                            }
                        }
                        else {
                            console.log('Something went wrong!');
                        }
                    });
                    return data;
                }
            }
            else {
                console.log('something went wrong');
                return -1;
            }
        })
    }
    const editClicked = () => {
        setClickSC(true);
        document.getElementById('drivingUpload').readOnly = false;
        document.getElementById('drivingLicenseNum').readOnly = false;
        setClickId(false);
        setClickEdit(true);
        setClickSave(false);
    }
    const saveClicked = event => {
        event.preventDefault();
        setClickSC(true);
        setPassportNum(passportNum);
        setPassportDOBDate(passportDOBDate);
        setSACitizenDOBDate(SACitizenDOBDate);
        setPassDOBValue(passDOBValue);
        setSACitizenDOBValue(SACitizenDOBValue);
        setCountryp(countryp);
        setNationalId(nationalId);
        setDrivingLicenseNum(drivingLicenseNum);
        setDrivingExpiryDate(drivingExpiryDate);
        setCalendarValueDriver(calendarValueDriver);
        setCountry(country);
        document.getElementById('drivingUpload').readOnly = true;
        document.getElementById('drivingLicenseNum').readOnly = true;
        if (viewProfileStatus === 'add-profile' && !getTaskId) {
            workFlowApiNewDriver('save');
        } else if (viewProfileStatus === 'add-profile' && getTaskId) {
            workFlowApiCompleteDriver('save');
        } else if (['Not Completed', 'Not completed', 'not completed', 'NOT COMPLETED'].includes(viewProfileStatus)) {
            workFlowApiCompleteDriver('save');
        } else if (['rejected', 'Rejected', 'REJECTED'].includes(viewProfileStatus)) {
            workFlowReworkDriver('save');
        }
        setClickId(true);
        setClickEdit(false);
        setClickSave(true);
    }
    const onCloseModal = () => {
        setHasOpen(false);
        history.push({
            pathname: '/home'
        });
    };
    const onClosePending = () => {
        setHasOpenPending(false);
    };
    const selectSACitizen = () => {
        setSelectOneRadioerror('');
        setSelectRadioSACitizen(true);
        setSelectRadioForeignDriver(false)
    }
    const selectForeignDriver = () => {
        setSelectOneRadioerror('');
        setSelectRadioSACitizen(false);
        setSelectRadioForeignDriver(true)
    }
    const handleClickOutside = event => {
        if (container.current && !container.current.contains(event.target)) {
            setContrycode(false);
            setContrycodep(false);
            setShowPassDOBCalendar(false);
            setShowSACitizenDOBCalendar(false);
            setShowCalendar(false);
        }
    };
    document.addEventListener("mousedown", handleClickOutside);
    const toggleContryCode = () => {
        setContrycode(!contrycode);
    };
    const toggleContryCodep = () => {
        setContrycodep(!contrycodep);
    };
    const changeCountryCode = (event) => {
        const foundc = countries?.find((name) => {
            if (name.name + ' (' + name.code + ')' === event.target.innerText) {
                return name
            }
        })
        setCountry(foundc.name + ' (' + foundc.code + ')');
        setCountryError();
        document.getElementById('drivingCountry').style.borderColor = ColorCode.colorCode.black;
        setContrycode(false);
    };
    const changeCountryCodep = (event) => {
        const foundcp = countries?.find((name) => {
            if (name.name + ' (' + name.code + ')' === event.target.innerText) {
                return name
            }
        })
        setCountryp(foundcp.name + ' (' + foundcp.code + ')');
        setCountrypError();
        document.getElementById('passportCountry').style.borderColor = ColorCode.colorCode.black;
        setContrycodep(false);
    };
    const handleChangePassportNum = (e) => {
        setPassportNum(e.target.value);
        setPassportNumError();
        document.getElementById('passportNum').style.borderColor = ColorCode.colorCode.black;
    }
    const handleChangePassportDOBDate = (e) => {
        setPassportDOBDate(e.target.value);
        setPassportDOBDate();
        document.getElementById('passportDOBDate').style.borderColor = ColorCode.colorCode.black;
    }
    const handleChangeSACitizenDOBDate = (e) => {
        setSACitizenDOBDate(e.target.value);
        setSACitizenDOBDate();
        document.getElementById('SACitizenDOBDate').style.borderColor = ColorCode.colorCode.black;
    }
    const handleChangeNationalId = (e) => {
        setNationalId(e.target.value);
        setNationalIdError();
        document.getElementById('nationalId').style.borderColor = ColorCode.colorCode.black;
    }
    const handleChangeDrivingLicenseNum = (e) => {
        setDrivingLicenseNum(e.target.value);
        setDrivingLicenseNumError();
        document.getElementById('drivingLicenseNum').style.borderColor = ColorCode.colorCode.black;
    }
    const handleChangeDrivingExpiryDate = (e) => {
        setDrivingExpiryDate(e.target.value);
        setDrivingExpiryDateError();
        document.getElementById('drivingExpiryDate').style.borderColor = ColorCode.colorCode.black;
    }
    const handleDateChanged = (e) => {
        setDrivingExpiryDate(getDateFormated(e));
        setCalendarValueDriver(e);
        setDrivingExpiryDateError();
        document.getElementById('drivingExpiryDate').style.borderColor = ColorCode.colorCode.black;
    }
    const handleDatePassDOBChanged = (e) => {
        setPassDOBValue(e);
        setPassportDOBDate(getDateFormated(e));
        setPassportDOBDateError();
        document.getElementById('passportDOBDate').style.borderColor = ColorCode.colorCode.black;
    }
    const handleDateSACitizenDOBChanged = (e) => {
        setSACitizenDOBValue(e);
        setSACitizenDOBDate(getDateFormated(e));
        setSACitizenDOBDateError();
        document.getElementById('SACitizenDOBDate').style.borderColor = ColorCode.colorCode.black;
    }
    const validate = () => {
        let isValid = true;
        var patternDigit = new RegExp(/^[0-9\b]+$/);
        var patternAlphaNumeric = new RegExp(/^(?=.*[a-zA-Z])(?=.*[0-9])[A-Za-z0-9]+$/);
        if (!country) {
            isValid = false;
            countryError = Message.validation.required;
            document.getElementById('drivingCountry').style.borderColor = ColorCode.colorCode.red;
        }
        else {
            document.getElementById('drivingCountry').style.borderColor = ColorCode.colorCode.black;
        }
        if (!SelectRadioForeignDriver && !SelectRadioSACitizen) {
            isValid = false;
            selectOneRadioError = Message.validation.required;
        }
        if (SelectRadioForeignDriver) {
            if (!passportNum) {
                isValid = false;
                passportNumError = Message.validation.required;
                document.getElementById('passportNum').style.borderColor = ColorCode.colorCode.red;
            }
            else {
                document.getElementById('passportNum').style.borderColor = ColorCode.colorCode.black;
            }
            if (!countryp) {
                isValid = false;
                countrypError = Message.validation.required;
                document.getElementById('passportCountry').style.borderColor = ColorCode.colorCode.red;
            }
            else {
                document.getElementById('passportCountry').style.borderColor = ColorCode.colorCode.black;
            }
            if (!dateDOBExpirySet) {
                if (!passportDOBDate) {
                    isValid = false;
                    passportDOBDateError = Message.validation.required;
                    document.getElementById('passportDOBDate').style.borderColor = ColorCode.colorCode.red;
                }
                else {
                    document.getElementById('passportDOBDate').style.borderColor = ColorCode.colorCode.black;
                }
            } else {
                passportDOBDateError = "";
                document.getElementById('passportDOBDate').style.borderColor = ColorCode.colorCode.black;
            }
        }
        if (SelectRadioSACitizen) {
            if (!nationalId) {
                isValid = false;
                nationalIdError = Message.validation.required;
                document.getElementById('nationalId').style.borderColor = ColorCode.colorCode.red;
            } else if (!patternDigit.test(nationalId)) {
                isValid = false;
                nationalIdError = Message.validation.num;
                document.getElementById('nationalId').style.borderColor = ColorCode.colorCode.red;
            }
            else {
                document.getElementById('nationalId').style.borderColor = ColorCode.colorCode.black;
            }
            if (!dateDOBSACitizenSet) {
                if (!SACitizenDOBDate) {
                    isValid = false;
                    SACitizenDOBDateError = Message.validation.required;
                    document.getElementById('SACitizenDOBDate').style.borderColor = ColorCode.colorCode.red;
                }
                else {
                    document.getElementById('SACitizenDOBDate').style.borderColor = ColorCode.colorCode.black;
                }
            } else {
                SACitizenDOBDateError = "";
                document.getElementById('SACitizenDOBDate').style.borderColor = ColorCode.colorCode.black;
            }
        }
        if (!drivingLicenseNum) {
            isValid = false;
            drivingLicenseNumError = Message.validation.required;
            document.getElementById('drivingLicenseNum').style.borderColor = ColorCode.colorCode.red;
        } else if (!patternAlphaNumeric.test(drivingLicenseNum)) {
            isValid = false;
            drivingLicenseNumError = Message.validation.alphanum;
            document.getElementById('drivingLicenseNum').style.borderColor = ColorCode.colorCode.red;
        }
        else {
            document.getElementById('drivingLicenseNum').style.borderColor = ColorCode.colorCode.black;
        }
        if (!dateSet) {
            if (!drivingExpiryDate) {
                isValid = false;
                drivingExpiryDateError = Message.validation.required;
                document.getElementById('drivingExpiryDate').style.borderColor = ColorCode.colorCode.red;
            }
            else {
                document.getElementById('drivingExpiryDate').style.borderColor = ColorCode.colorCode.black;
            }
        } else {
            drivingExpiryDateError = "";
            document.getElementById('drivingExpiryDate').style.borderColor = ColorCode.colorCode.black;
        }
        if (fileNameDriver?.length === 0 || filePathDriver?.length === 0) {
            isValid = false;
            uploadError = Message.validation.required;
            document.getElementById('drivingUpload').style.borderColor = ColorCode.colorCode.red;
        } else {
            uploadError = "";
            document.getElementById('drivingUpload').style.borderColor = ColorCode.colorCode.black;
        }
        if (SelectRadioSACitizen && fileNameNational?.length === 0 && filePathNational?.length === 0) {
            isValid = false;
            upload1Error = Message.validation.required;
            document.getElementById('nationalUpload').style.borderColor = ColorCode.colorCode.red;
        } else if (SelectRadioSACitizen) {
            upload1Error = "";
            document.getElementById('nationalUpload').style.borderColor = ColorCode.colorCode.black;
        }
        if (SelectRadioForeignDriver && fileNamePassport?.length === 0 && filePathPassport?.length === 0) {
            isValid = false;
            upload2Error = Message.validation.required;
            document.getElementById('passportUpload').style.borderColor = ColorCode.colorCode.red;
        } else if (SelectRadioForeignDriver) {
            upload2Error = "";
            document.getElementById('passportUpload').style.borderColor = ColorCode.colorCode.black;
        }
        setSelectOneRadioerror(selectOneRadioError);
        setPassportNumError(passportNumError);
        setPassportDOBDateError(passportDOBDateError);
        setSACitizenDOBDateError(SACitizenDOBDateError);
        setNationalIdError(nationalIdError);
        setDrivingLicenseNumError(drivingLicenseNumError);
        setDrivingExpiryDateError(drivingExpiryDateError);
        setCountryError(countryError);
        setCountrypError(countrypError);
        setUploadError(uploadError);
        setUpload1Error(upload1Error);
        setUpload2Error(upload2Error);
        return isValid;
    }
    const validateDriverLicense = () => {
        if (drivingLicenseNum?.trim()?.length > 0) {
            setDrivingLicenseNum(drivingLicenseNum?.trim())
            ApiCall(
                'GET',
                utilityBaseURL + VALIDATE_DRIVING_LICENCE + `?driverLicenseNo=${drivingLicenseNum?.trim()}`,
                {},
                {
                    Accept: 'application/json',
                    'Content-Type': 'application/json',
                },
            ).then((apiData) => {
                if (apiData.flag != -1) {
                    if (apiData.flag == 500) {
                        console.log('I am 500!');
                        setDriverLicenceError(true);
                        setHasOpenPending(true);
                    }
                    else {
                        console.log('I am 200!');
                    }
                }
                else {
                    console.log(`Some error occured `);
                }
            });
        }
    }
    const openPOPIDisclaimer = () => {
        setHasOpenPOPIDisclaimer(true)
    }
    const onCrossPOPIDisclaimerModal = () => {
        setHasOpenPOPIDisclaimer(false)
    }
    const handleAgree = () => {
        if (hasAgreePOPIDisclaimer) {
            setHasAgreePOPIDisclaimer(false);
            setPassportNum(passportNum);
            setPassportDOBDate(passportDOBDate);
            setSACitizenDOBDate(SACitizenDOBDate);
            setNationalId(nationalId);
            setDrivingLicenseNum(drivingLicenseNum);
            setDrivingExpiryDate(drivingExpiryDate);
            if (viewProfileStatus === 'add-profile' && !getTaskId) {
                workFlowApiNewDriver('submit');
            } else if (viewProfileStatus === 'add-profile' && getTaskId) {
                workFlowApiCompleteDriver('submit');
            } else if (['Not Completed', 'Not completed', 'not completed', 'NOT COMPLETED'].includes(viewProfileStatus)) {
                workFlowApiCompleteDriver('submit');
            } else if (['Approved', 'approved', 'APPROVED'].includes(viewProfileStatus)) {
                workFlowApiNewDriver('submit');
            } else if (['rejected', 'Rejected', 'REJECTED'].includes(viewProfileStatus)) {
                workFlowReworkDriver('submit');
            }
        }
    }
    const onSubmit = (event) => {
        event.preventDefault();
        if (validate()) {
            setHasAgreePOPIDisclaimer(true)
        }
    }
    const ccode = contrycode ? < img class="ccodeimg1" src={updrawer} /> : <img class="ccodeimg1" src={downarrow} />
    const ccodep = contrycodep ? < img class="ccodeimg1" src={updrawer} /> : <img class="ccodeimg1" src={downarrow} />
    const months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
    let formatted_date = calendarValueDriver.getDate() + "-" + months[calendarValueDriver.getMonth()] + "-" + calendarValueDriver.getFullYear();
    if (calendarValueDriver.getDate() <= 9) {
        formatted_date = "0" + calendarValueDriver.getDate() + "-" + months[calendarValueDriver.getMonth()] + "-" + calendarValueDriver.getFullYear();
    }
    let passDOBFormatted_date = passDOBValue?.getDate() + "-" + months[passDOBValue.getMonth()] + "-" + passDOBValue.getFullYear();
    if (passDOBValue.getDate() <= 9) {
        passDOBFormatted_date = "0" + passDOBValue.getDate() + "-" + months[passDOBValue.getMonth()] + "-" + passDOBValue.getFullYear();
    }
    let SACitizenDOBFormatted_date = SACitizenDOBValue.getDate() + "-" + months[SACitizenDOBValue.getMonth()] + "-" + SACitizenDOBValue.getFullYear();
    if (SACitizenDOBValue.getDate() <= 9) {
        SACitizenDOBFormatted_date = "0" + SACitizenDOBValue.getDate() + "-" + months[SACitizenDOBValue.getMonth()] + "-" + SACitizenDOBValue.getFullYear();
    }
    return (
        <div class="outcolor" id={pageDisable ? "disabletrue" : ""}>
            <MetaDecorator title={TitleDescription.driverProfilePageTitle} description={TitleDescription.driverProfilePageDescription} />
            <Loader
                loaded={!loadertime}
                lines={10}
                length={10}
                width={8}
                radius={10}
                corners={1}
                rotate={0}
                direction={1}
                color="#000"
                speed={1}
                trail={60}
                shadow={false}
                hwaccel={false}
                className="spinner"
                zIndex={2e9}
                top="50%"
                left="50%"
                scale={1.0}
                loadedClassName="loadedContent"
            />
            <div class="idfullon">
                <Header tilesFetched={() => { }} />
                <div id="boox3">
                    <div className="" class="DriverProfilenavbar">
                        <div className="DriverProfilenavbarname">
                            <small id="navc">My Profile</small>
                        </div>
                        <div class="navsave ">
                            {
                                phone ?
                                    <div>
                                        {
                                            profileApproved.includes(viewProfileStatus) || profileReject.includes(viewProfileStatus) ?
                                                <div>
                                                    {
                                                        clickEdit ?
                                                            <div>
                                                                <img src={editlight} class=" mr-1 pb-1" id="editicon" alt="" loading="lazy" />
                                                                <small id="editlight" class=" pr-4" >Edit</small>
                                                            </div>
                                                            :
                                                            <div>
                                                                <img src={edit} class=" mr-1 pb-1" id="editicon" alt="" loading="lazy" />
                                                                <small id="edit" class=" pr-4" onClick={editClicked} >Edit</small>
                                                            </div>
                                                    }
                                                </div>
                                                :
                                                <div>
                                                    {
                                                        profilePending.includes(viewProfileStatus) ?
                                                            <div>
                                                                <img src={editlight} class=" mr-1 pb-1" id="editicon" alt="" loading="lazy" />
                                                                <small id="editlight" class=" pr-4" >Edit</small>
                                                                <img src={save} class=" mr-1 pb-1" id="saveicon" alt="" loading="lazy" />
                                                                <small id="save" >Save</small>
                                                            </div>
                                                            :
                                                            <div>
                                                                {
                                                                    profileIncomplete.includes(viewProfileStatus) ?
                                                                        <div>
                                                                            {
                                                                                clickEdit ?
                                                                                    <div>
                                                                                        <img src={editlight} class=" mr-1 pb-1" id="editicon" alt="" loading="lazy" />
                                                                                        <small id="editlight" class=" pr-4" >Edit</small>
                                                                                        <img src={savedark} class=" mr-1 pb-1" id="saveicon" alt="" loading="lazy" />
                                                                                        <small id="savedark" onClick={saveClicked} >Save</small>
                                                                                    </div>
                                                                                    :
                                                                                    <div>
                                                                                        <img src={edit} class=" mr-1 pb-1" id="editicon" alt="" loading="lazy" />
                                                                                        <small id="edit" class=" pr-4" onClick={editClicked} >Edit</small>
                                                                                        <img src={save} class=" mr-1 pb-1" id="saveicon" alt="" loading="lazy" />
                                                                                        <small id="save" >Save</small>
                                                                                    </div>
                                                                            }
                                                                        </div>
                                                                        :
                                                                        <div>
                                                                            {clickEdit ?
                                                                                <div>
                                                                                    <img src={editlight} class=" mr-1 pb-1" id="editicon" alt="" loading="lazy" />
                                                                                    <small id="editlight" class=" pr-4" >Edit</small>
                                                                                    <img src={savedark} class=" mr-1 pb-1" id="saveicon" alt="" loading="lazy" />
                                                                                    <small id="savedark" onClick={saveClicked} >Save</small>
                                                                                </div>
                                                                                :
                                                                                <div>
                                                                                    <img src={edit} class=" mr-1 pb-1" id="editicon" alt="" loading="lazy" />
                                                                                    <small id="edit" class=" pr-4" onClick={editClicked} >Edit</small>
                                                                                    <img src={save} class=" mr-1 pb-1" id="saveicon" alt="" loading="lazy" />
                                                                                    <small id="save" >Save</small>
                                                                                </div>
                                                                            }
                                                                        </div>
                                                                }
                                                            </div>
                                                    }
                                                </div>
                                        }
                                    </div>
                                    :
                                    <div>
                                        {clickSave ?
                                            <div>
                                                <img src={edit} class=" mr-1 pb-1" id="editicon" alt="" loading="lazy" />
                                                <small id="edit" class=" pr-4" onClick={editClicked} >Edit</small>
                                                <img src={save} class=" mr-1 pb-1" id="saveicon" alt="" loading="lazy" />
                                                <small id="save" >Save</small>
                                            </div>
                                            :
                                            <div>
                                                <img src={editlight} class=" mr-1 pb-1" id="editicon" alt="" loading="lazy" />
                                                <small id="editlight" class=" pr-4" >Edit</small>
                                                <img src={savedark} class=" mr-1 pb-1" id="saveicon" alt="" loading="lazy" />
                                                <small id="savedark" onClick={saveClicked} >Save</small>
                                            </div>
                                        }
                                    </div>
                            }
                        </div>
                    </div>
                    <hr class="hr1" />
                    <div class="maincardIdInfo">
                        <div class="DriverCardHeadingDiv">
                            <small id="DriverCardHeading">Select Citizenship</small>
                        </div>
                        <div class="SelectCitizenshipOuterCardCss" id={(clickSave || (phone && !clickEdit)) && "MakeDriverFormDivPointerNone"}>
                            <div class="SelectCitizenshipDiv">
                                <div class="CitizenshipOptionDiv" onClick={selectSACitizen}>
                                    <img class="CitizenshipOptionImg"
                                        src={SelectRadioSACitizen ? selectedRadioButton : defautRadioButton} />
                                    <small class="CitizenshipOptionText">South African Citizen / Resident</small>
                                </div>
                                <div class="CitizenshipOptionDiv" id="ForeignDriver" onClick={selectForeignDriver}>
                                    <img class="CitizenshipOptionImg"
                                        src={SelectRadioForeignDriver ? selectedRadioButton : defautRadioButton} />
                                    <small class="CitizenshipOptionText">Foreign Driver / Non-Resident</small>
                                </div>
                            </div>
                            <div className="idInfoerror12">{selectOneRadioError}</div>
                        </div>
                        {SelectRadioForeignDriver && (
                            <>
                                <div class="DriverSelectIdOuterCardCss" id={(clickSave || (phone && !clickEdit)) && "MakeDriverFormDivPointerNone"}>
                                    <div class="DriverDivCardCss">
                                        <div class="DriverInputDivCss">
                                            <small id="name">Passport No.</small>
                                            <br />
                                            <Input
                                                class="input"
                                                type="text"
                                                id="passportNum"
                                                name="passportNum"
                                                autoComplete="off"
                                                value={passportNum}
                                                onChange={handleChangePassportNum} />
                                            <div className="idInfoerror12">{passportNumError}</div>
                                        </div>
                                        <div class="DriverExpiryDateInputDivCss">
                                            <small id="name">Expiry Date</small>
                                            <br />
                                            <div className="pass-wrapper classposition121" id="calenderstylew">
                                                <input
                                                    readOnly
                                                    class="inpuut1"
                                                    placeholder="Select Date"
                                                    type="text"
                                                    id="passportDOBDate"
                                                    name="passportDOBDate"
                                                    autoComplete="off"
                                                    value={showPassDOBCalendar ? passDOBFormatted_date : passportDOBDate}
                                                    onChange={handleChangePassportDOBDate} />
                                                <div className="idInfoerror12">{passportDOBDateError}</div>
                                                <div class="idcalenderwidth">  {showPassDOBCalendar ? <div ref={container}>  <Calendar onChange={handleDatePassDOBChanged} value={passDOBValue} /></div> : null}</div>
                                                <img id="ppinput_img2" src={calender} alt="" onClick={clickPassId ? null : togglePassDOBCalendar}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                    <div class="DriverDivCardBottomCss">
                                        <div class="DriverInputDivCss">
                                            <small id="name">Country of issue</small>
                                            <br />
                                            <div className="pass-wrapper classposition"  >
                                                <input class="input" id="passportCountry" value={countryp} placeholder="Select Country" type="text" readOnly />
                                                <i id="input_imgPassport" onClick={clickPassId ? null : toggleContryCodep} >{ccodep}</i>
                                            </div>
                                            <div className="idInfoerror12">{countrypError}</div>
                                            {contrycodep && (
                                                <div class="ccodead081" >
                                                    <div class="ccodeiddropdowncard" ref={container}>
                                                        {(countries?.map((cname, index) => {
                                                            return (
                                                                <DropDownTable id="IdInfofmationDropDownTable" onClick={(index1) => changeCountryCodep(index1)} >
                                                                    <small class="pl-3" id="ccodeidtt2" >{cname.name} ({cname.code})</small>
                                                                </DropDownTable>
                                                            );
                                                        }))}
                                                    </div>
                                                </div>
                                            )}
                                        </div>
                                        <div class="DriverInputDivCss">
                                            <small id="name" class="DriverLDisplayN"></small>
                                            <br class="DriverLDisplayN" />
                                            {uploadFileDisablePassport &&
                                                <Upload uploaddivid="passportUpload" id1="passportupload_link" idupload="passportupload" name="passportfileupload"
                                                    setUploadConfirm={uploadFileFunPassport}
                                                    removeLink={removePassPortUploadedLink}
                                                    setFileLink={setUploadLinkPassport}
                                                    setLoader={setLoaderPassport}
                                                    pdfFileName={fileNamePassport}
                                                    isUploadDisabled={uploadFileDisablePassport}
                                                    staticFileName={'Passport.'}
                                                    fileType="png, jpg, pdf"
                                                />
                                            }
                                            {!uploadFileDisablePassport &&
                                                <Upload uploaddivid="passportUpload" id1="passportupload_link" idupload="passportupload" name="passportfileupload"
                                                    setUploadConfirm={uploadFileFunPassport}
                                                    removeLink={removePassPortUploadedLink}
                                                    setFileLink={setUploadLinkPassport}
                                                    setLoader={setLoaderPassport}
                                                    pdfFileName={fileNamePassport}
                                                    isUploadDisabled={uploadFileDisablePassport}
                                                    staticFileName={'Passport.'}
                                                    fileType="png, jpg, pdf"
                                                />
                                            }
                                            <div className="error1">{upload2Error}</div>
                                        </div>
                                    </div>
                                </div>
                            </>
                        )}
                        {SelectRadioSACitizen && (
                            <>
                                <div class="DriverSelectIdOuterCardCss" id={(clickSave || (phone && !clickEdit)) && "MakeDriverFormDivPointerNone"}>
                                    <div class="DriverDivCardCss">
                                        <div class="DriverInputDivCss">
                                            <small id="name">South African ID No.</small>
                                            <br />
                                            <Input
                                                class="input"
                                                type="text"
                                                id="nationalId"
                                                name="nationalId"
                                                autoComplete="off"
                                                value={nationalId}
                                                onChange={handleChangeNationalId} />
                                            <div className="idInfoerror12">{nationalIdError}</div>
                                        </div>
                                        <div class="DriverExpiryDateInputDivCss">
                                            <small id="name">Date of Birth</small>
                                            <br />
                                            <div className="pass-wrapper classposition121" id="calenderstylew">
                                                <input
                                                    readOnly
                                                    class="inpuut1"
                                                    placeholder="Select Date"
                                                    type="text"
                                                    id="SACitizenDOBDate"
                                                    name="SACitizenDOBDate"
                                                    autoComplete="off"
                                                    value={showSACitizenDOBCalendar ? SACitizenDOBFormatted_date : SACitizenDOBDate}
                                                    onChange={handleChangeSACitizenDOBDate} />
                                                <div className="idInfoerror12">{SACitizenDOBDateError}</div>
                                                <div class="idcalenderwidth">  {showSACitizenDOBCalendar ? <div ref={container}>  <Calendar onChange={handleDateSACitizenDOBChanged} value={SACitizenDOBValue} /></div> : null}</div>
                                                <img id="ppinput_img2" src={calender} alt="" onClick={clickPassId ? null : toggleSACitizenDOBCalendar}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                    <div class="DriverDivCardBottomCss">
                                        <div class="DriverInputDivCss">
                                            <small class="DriverLDisplayN"></small>
                                            <br class="DriverLDisplayN" />
                                            {uploadFileDisableNational &&
                                                <Upload uploaddivid="nationalUpload" id1="nationalupload_link" idupload="nationalupload" name="nationalfileupload"
                                                    setUploadConfirm={uploadFileFunNational}
                                                    removeLink={removeNationalUploadedLink}
                                                    setFileLink={setUploadLinkNational}
                                                    setLoader={setLoaderNational}
                                                    pdfFileName={fileNameNational}
                                                    isUploadDisabled={uploadFileDisableNational}
                                                    staticFileName={'National_Id.'}
                                                    fileType="png, jpg, pdf" />
                                            }
                                            {!uploadFileDisableNational &&
                                                <Upload uploaddivid="nationalUpload" id1="nationalupload_link" idupload="nationalupload" name="nationalfileupload"
                                                    setUploadConfirm={uploadFileFunNational}
                                                    removeLink={removeNationalUploadedLink}
                                                    setFileLink={setUploadLinkNational}
                                                    setLoader={setLoaderNational}
                                                    pdfFileName={fileNameNational}
                                                    isUploadDisabled={uploadFileDisableNational}
                                                    staticFileName={'National_Id.'}
                                                    fileType="png, jpg, pdf" />
                                            }
                                            <div className="error1">{upload1Error}</div>
                                        </div>
                                    </div>
                                </div>
                            </>
                        )}
                        <div class="DriverLCardHeadingDiv">
                            <small id="DriverCardHeading">Driving License Information</small>
                        </div>
                        <div class="DriverOuterCardCss" id={(clickSave || (phone && !clickEdit)) && "MakeDriverFormDivPointerNone"}>
                            <div class="DriverDivCardCss">
                                <div class="DriverInputDivCss">
                                    <small id="name">Driving License No.</small>
                                    <br />
                                    <Input
                                        class="input"
                                        type="text"
                                        onBlur={() => validateDriverLicense()}
                                        id="drivingLicenseNum"
                                        name="drivingLicenseNum"
                                        autoComplete="off"
                                        value={drivingLicenseNum}
                                        onChange={handleChangeDrivingLicenseNum} />
                                    <div className="idInfoerror12">{drivingLicenseNumError}</div>
                                </div>
                                <div class="DriverExpiryDateInputDivCss">
                                    <small id="name">Expiry Date</small>
                                    <br />
                                    <div className="pass-wrapper classposition121" id="calenderstylew"
                                    >
                                        <input
                                            readOnly
                                            class="inpuut1"
                                            placeholder="Select Date"
                                            type="text"
                                            id="drivingExpiryDate"
                                            name="drivingExpiryDate"
                                            autoComplete="off"
                                            value={showCalendar ? formatted_date : drivingExpiryDate}
                                            onChange={handleChangeDrivingExpiryDate} />
                                        <div className="idInfoerror12">{drivingExpiryDateError}</div>
                                        <div class="idcalenderwidth">      {showCalendar ? <div ref={container}>  <Calendar onChange={handleDateChanged} value={calendarValueDriver} /> </div> : null}</div>
                                        <img id="ppinput_img2" src={calender} onClick={clickId ? null : toggleCalendar}
                                        />
                                    </div>
                                </div>
                            </div>
                            <div class="DriverDivCardBottomCss">
                                <div class="DriverInputDivCss" >
                                    <small id="name">Country of issue</small>
                                    <br />
                                    <div className="pass-wrapper" style={{ position: "relative" }} >
                                        <input class="input" id="drivingCountry" value={country} placeholder="Select Country" type="text" readOnly />
                                        <i id="input_imgIdInfo22" onClick={clickId ? null : toggleContryCode} >{ccode}</i>
                                    </div>
                                    <div className="idInfoerror12">{countryError}</div>
                                    {contrycode && (
                                        <div class="ccodead081" >
                                            <div class="ccodeiddropdowncard" ref={container}>
                                                {(countries?.map((cname, index) => {
                                                    return (
                                                        <DropDownTable id="IdInfofmationDropDownTable" onClick={(index1) => changeCountryCode(index1)} >
                                                            <small class="pl-3" id="ccodeidtt2" >{cname.name} ({cname.code})</small>
                                                        </DropDownTable>
                                                    );
                                                }))}
                                            </div>
                                        </div>
                                    )}
                                </div>
                                <div class="DriverInputDivCss">
                                    <small class="DriverLDisplayN" /><br class="DriverLDisplayN" />
                                    {uploadFileDisableDriver &&
                                        <Upload uploaddivid="drivingUpload"
                                            id1="upload_link"
                                            idupload="upload"
                                            name="fileupload"
                                            fileType="png, jpg, pdf"
                                            setUploadConfirm={uploadFileFunDriver}
                                            removeLink={removeDriverUploadedLink}
                                            setFileLink={setUploadLinkDriver}
                                            setLoader={setLoaderDriver}
                                            pdfFileName={fileNameDriver}
                                            isUploadDisabled={uploadFileDisableDriver}
                                            staticFileName={'Driving_License.'}
                                        />
                                    }
                                    {!uploadFileDisableDriver &&
                                        <Upload uploaddivid="drivingUpload" id1="upload_link" idupload="upload" name="fileupload"
                                            fileType="png, jpg, pdf"
                                            setUploadConfirm={uploadFileFunDriver}
                                            removeLink={removeDriverUploadedLink}
                                            setFileLink={setUploadLinkDriver}
                                            setLoader={setLoaderDriver}
                                            pdfFileName={fileNameDriver}
                                            isUploadDisabled={uploadFileDisableDriver}
                                            staticFileName={'Driving_License.'}
                                        />
                                    }
                                    <div className="error1">{uploadError}</div>
                                </div>
                            </div>
                        </div>
                        <div class="DriverProfilePopiDiv" onClick={openPOPIDisclaimer}>POPI Disclaimer</div>
                        <div class="DriverProfileBtnDiv">
                            <Button id="bttn" class="bttn1 " onClick={onSubmit}>Submit</Button>
                        </div>
                    </div>
                </div>
                <div class="idfooter22">
                    <Footer2 />
                </div>
            </div>
            <div class="idfooter11">
                <Footer />
                {hasOpenterms ? <TermsConditionModal onClick={onClosetermsModal} /> : null}
                <SubmitModal hasOpen={hasOpen} onCloseModal={onCloseModal} />
                {/* pending state pop up modal */}
                {hasOpenPending ? <AddProfileModal hasOpen={hasOpenPending} onCloseModal={onClosePending} >
                    <div>
                        <div class="successtext1outercreatepreadvise">
                            <small class="addprofilemodalsmall">{driverLicenceError
                                ?
                                'The Driver details are not present in DTMS. Please register in DTMS to use the CC App services.'
                                : Message.profileManagement.pendingProfile}</small>
                        </div>
                    </div>
                </AddProfileModal> : null}
                {hasOpenPOPIDisclaimer ?
                    <POPIDisclaimerModal
                        showButton={false}
                        hasOpen={hasOpenPOPIDisclaimer}
                        onCrossModal={onCrossPOPIDisclaimerModal}
                    >
                    </POPIDisclaimerModal>
                    : null
                }
                {hasAgreePOPIDisclaimer ?
                    <POPIDisclaimerModal
                        showButton={true}
                        hasOpen={hasAgreePOPIDisclaimer}
                        onCloseModal={handleAgree}
                        buttonLabel={"Agree"}
                    >
                    </POPIDisclaimerModal>
                    : null
                }
            </div>
        </div>
    );
}
export default DriverProfile;